import { api } from './api';
import { API_ENDPOINTS } from './endpoints';

export interface Shipping {
  id: number;
  name: string;
  code: string;
  description?: string;
  price: number;
  active: boolean;
  order: number;
}

export const shippingService = {
  getAll: () => api.get(API_ENDPOINTS.SHIPPINGS.INDEX),
  
  create: (data: { name: string; code: string; price: number; description?: string; active?: boolean; order?: number }) => 
    api.post(API_ENDPOINTS.SHIPPINGS.STORE, data),
};
